import { TGetSubscriptionsQuery } from '@/modules/Subscriptions/helpers/types';
import { showApiErrors } from '@/utils';
import { createSlice, isPending, isRejected, PayloadAction } from '@reduxjs/toolkit';
import { deleteSubscription, getSubscriptions } from './actionCreators';
import { initialState, SUBSCRIPTIONS_SLICE_NAME, SubscriptionsState } from './models';

export const slice = createSlice({
  name: SUBSCRIPTIONS_SLICE_NAME,
  initialState,
  reducers: {
    resetState: () => initialState,

    changeQuery: (state, action: PayloadAction<TGetSubscriptionsQuery>) => {
      state.query = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getSubscriptions.fulfilled, (state: SubscriptionsState, action) => {
        state.subscriptions = action.payload.data;
        state.isLoading = false;
        state.error = null;
        state.pagination = action.payload.meta;
      })
      .addCase(deleteSubscription.fulfilled, (state: SubscriptionsState, action) => {
        const id = action.meta.arg;

        state.subscriptions = (state.subscriptions ?? []).filter((subscription) => subscription.id !== id);
        state.isLoading = false;
        state.error = null;
      })
      .addMatcher(isPending(getSubscriptions, deleteSubscription), (state: SubscriptionsState) => {
        state.isLoading = true;
        state.error = null;
      })
      .addMatcher(isRejected(getSubscriptions, deleteSubscription), (state: SubscriptionsState, action) => {
        const { error } = action;
        state.error = error;
        state.isLoading = false;

        showApiErrors(error);
      });
  },
});

export const { resetState, changeQuery } = slice.actions;

export default slice.reducer;
